import React from 'react';
import mergeClassnames from '../../mergeClassnames/mergeClassnames';
import getIconSize from '../private/utils/buttonSizes/getIconSize';
import getIconHorizontalPosition from '../private/utils/buttonStyles/getIconHorizontalPosition';
const IconRight = ({ fullWidth, iconRight, size }) => (React.createElement("span", { "aria-hidden": "true", className: mergeClassnames(getIconSize(size), fullWidth &&
        `absolute block top-1/2 translate-y-[-50%] ${getIconHorizontalPosition({
            iconRight,
            size,
        })}`) }, iconRight));
export default IconRight;
